export default __webpack_public_path__ + "static/media/icon02.a6bde0ed.png";